module.exports = __webpack_public_path__ + "71923a18019d6cb8a54950e9aee6c7db.png";